var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DCCD"
    },
    d: "M430.496,107.755c0,16.803-13.622,30.425-30.425,30.425l0,0c-16.803,0-30.425-13.622-30.425-30.425 v-66.56c0-16.81,13.628-30.438,30.438-30.438l0,0c16.941,0,30.624,13.839,30.435,30.779 C430.366,55.485,430.496,107.755,430.496,107.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8A59A"
    },
    d: "M430.521,41.536c0.188-16.94-13.494-30.779-30.436-30.779c-4.165,0-8.129,0.846-11.744,2.36 c11.097,4.637,18.863,15.634,18.72,28.419c-0.156,13.948-0.024,66.219-0.024,66.219c0,12.644-7.718,23.475-18.695,28.069 c3.611,1.511,7.57,2.356,11.73,2.356c16.803,0,30.425-13.622,30.425-30.425C430.496,107.755,430.366,55.485,430.521,41.536z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.922,
    y: 381.584,
    style: {
      fill: "#E0DCCD"
    },
    width: 87.364,
    height: 26.083
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DCCD"
    },
    d: "M185.927,281.255h52.157l0,0c0,19.204-15.568,34.771-34.771,34.771h-17.386L185.927,281.255 L185.927,281.255z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 181.385,
    y: 192.412,
    style: {
      fill: "#FCBB3B"
    },
    width: 86.928,
    height: 86.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.385,
    y: 192.412,
    style: {
      fill: "#AF7C18"
    },
    width: 34.771,
    height: 86.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.922,
    y: 407.656,
    style: {
      fill: "#4BAF78"
    },
    width: 69.543,
    height: 104.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.613,
    y: 407.656,
    style: {
      fill: "#1E834E"
    },
    width: 17.386,
    height: 104.31
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BAF78"
    },
    d: "M142.463,33.866L142.463,33.866c0-14.403-11.676-26.079-26.079-26.079h-8.693 c-14.403,0-26.079,11.676-26.079,26.079v17.386h60.85V33.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E834E"
    },
    d: "M107.691,10.467h8.693c3.064,0,4.865-0.713,7.595,0.258c-10.106,3.593-18.483,11.804-18.483,23.142 v16.057h-24.92V33.866C80.576,19.463,93.288,10.467,107.691,10.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DCCD"
    },
    d: "M81.612,51.252v56.503c0,16.803,13.622,30.425,30.425,30.425l0,0 c16.803,0,30.425-13.622,30.425-30.425V51.252"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8A59A"
    },
    d: "M96.151,49.924v57.833c0,13.761,10.618,25.253,23.156,29.012c-2.771,0.831-5.456,1.413-8.499,1.413 c-16.803,0-30.231-13.622-30.231-30.425V49.924H96.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BAF78"
    },
    d: "M152.221,233.802v34.771v12.896h24.92v39.456h-24.92v17.19v46.147H80.576v-63.229V285.96V164.258 C121.071,164.258,152.221,195.395,152.221,233.802z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E834E"
    },
    points: "152.477,321.034 98.998,321.034 98.998,170.262 81.612,170.262 81.612,381.58 98.998,381.58  98.998,338.419 152.477,338.419 "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.037,145.968c-21.07,0-38.212-17.142-38.212-38.212V68.637h15.575v39.118c0,12.483,10.155,22.638,22.638,22.638 s22.638-10.155,22.638-22.638V68.637h15.575v39.118C150.25,128.826,133.107,145.968,112.037,145.968z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.62,59.039H73.825V33.866C73.825,15.192,89.017,0,107.69,0h8.693c18.674,0,33.866,15.192,33.866,33.866h-15.575 c0-10.085-8.206-18.291-18.291-18.291h-8.693c-10.085,0-18.29,8.206-18.29,18.291v9.598H194.62V59.039z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352.065,
    y: 381.584,
    style: {
      fill: "#E0DCCD"
    },
    width: 86.991,
    height: 26.083
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DCCD"
    },
    d: "M326.182,281.255h-52.157l0,0c0,19.204,15.568,34.771,34.771,34.771h17.386V281.255z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 368.449,
    y: 407.656,
    style: {
      fill: "#FCBB3B"
    },
    width: 64.604,
    height: 104.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.108,
    y: 407.656,
    style: {
      fill: "#AF7C18"
    },
    width: 19.936,
    height: 104.31
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75C0C7"
    },
    d: "M359.885,233.802v34.771v12.896h-24.92v39.456h24.92v17.19v46.147h71.644v-63.229V285.96V164.258 C391.035,164.258,359.885,195.395,359.885,233.802z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#589095"
    },
    points: "413.111,172.951 413.111,321.034 359.632,321.034 359.632,338.419 413.111,338.419  413.111,381.58 430.496,381.58 430.496,172.951 "
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400.071,145.968c-21.07,0-38.212-17.142-38.212-38.212V41.195c0-21.077,17.148-38.225,38.225-38.225 c10.29,0,19.942,4.03,27.178,11.347c7.237,7.318,11.16,17.016,11.045,27.306c-0.153,13.735-0.025,65.59-0.023,66.112v0.02 C438.284,128.826,421.142,145.968,400.071,145.968z M400.085,18.545c-12.489,0-22.65,10.161-22.65,22.65v66.56 c0,12.483,10.155,22.638,22.638,22.638c12.482,0,22.635-10.153,22.638-22.632c-0.002-1.116-0.129-52.551,0.024-66.31 c0.067-6.098-2.256-11.844-6.546-16.181C411.9,20.934,406.181,18.545,400.085,18.545z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.874,511.994l15.575-0.034l-0.118-53.721c15.466-3.125,27.147-16.82,27.147-33.194H99.903 c0,7.725-4.822,14.333-11.608,17.01l-0.059-26.638l46.435,0.02l-0.045,96.534l15.575,0.007l0.045-96.535l10.04,0.004l0.006-15.575 l-87.665-0.036L72.874,511.994z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M351.579,399.838v15.575h10.285l0.045,96.564l15.575-0.007l-0.045-96.557h46.247l-0.194,26.523 c-6.618-2.756-11.286-9.287-11.286-16.89H396.63c0,16.23,11.478,29.824,26.742,33.106l-0.392,53.736l15.575,0.113l0.82-112.162 h-87.796V399.838z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M351.844,336.945v55.522h87.203l-0.789-235.996h-7.761c-42.64,0-77.33,34.69-77.33,77.33v34.771h15.575v-34.771 c0-31.425,23.592-57.443,53.995-61.27l0.472,141.126h-88.243v-24.92h71.644v-71.644h-15.575v56.069l-114.932,0.293v-88.829H173.6 v88.536h-52.528v-56.069h-15.575v71.644h71.644v24.92H88.901l0.472-141.126c30.403,3.827,53.995,29.846,53.995,61.27v34.771h15.575 v-34.771c0-42.64-34.69-77.33-77.33-77.33h-7.761l-0.789,235.996h87.202v-55.522H144.69v39.947H88.689l0.16-47.661h103.868v-40.189 h36.436c-3.351,11.094-13.666,19.197-25.839,19.197v15.575c21.474,0,39.272-15.988,42.143-36.684h21.197 c2.872,20.695,20.671,36.684,42.143,36.684v-15.575c-12.192,0-22.52-8.126-25.853-19.247l36.448-0.209v40.45h103.87l0.16,47.661 h-56.001v-39.947h-15.577V336.945z M189.174,271.556v-71.354h23.27v11.7h15.575v-11.7h32.51v18.968h-32.51v15.575h32.51v9.345 h-24.203v15.575h24.203v11.891H189.174z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverSvgrepoCom);
export default __webpack_public_path__ + "static/media/deliver-svgrepo-com.4c5f950ceeaf31a50bb97addfe287420.svg";
export { ForwardRef as ReactComponent };